import React from 'react';

interface QuickActionsProps {
  onSelectAction: (action: string) => void;
}

const QuickActions: React.FC<QuickActionsProps> = ({ onSelectAction }) => {
  // Conversational presets — match the new single-chat surface.
  const actions = [
    { label: 'How is my portfolio doing today?', query: 'How is my portfolio doing today? Walk me through what stands out across my open positions.' },
    { label: 'Anything I should roll or close?', query: 'Looking at my active positions, is there anything I should consider rolling or closing right now? Why?' },
    { label: "What's the macro picture?", query: "What's happening in the broader market today? Anything important on the Fed, inflation, rates, or sector moves I should know about?" },
    { label: 'Find me a strong new setup', query: 'Find me one or two strong new covered-call setups based on the screener — explain in plain English why each one looks good.' },
  ];

  return (
    <div className="app-quick-actions">
      <span className="app-quick-actions-label">
        Suggested
      </span>
      {actions.map((action, index) => (
        <button
          key={index}
          onClick={() => onSelectAction(action.query)}
          className="app-quick-action-button"
        >
          {action.label}
        </button>
      ))}
    </div>
  );
};

export default QuickActions;